<template>
  <div>
    <el-dialog
      id="pwd"
      title=""
      :visible="dialogVisible"
      width="420px"
      :before-close="handleClose"
      :show-close="false"
      center
      :modal-append-to-body="false"
    >
      <span slot="footer" class="dialog-footer">
        <div class="loginC">
          <div class="previewLogin"></div>
          <h3 class="loginForget">修改密码</h3>
          <div class="allMessageLogin allMessageLoginPreview">
            <el-form
              :model="params"
              status-icon
              ref="ruleForm"
              label-width="60px"
              class="demo-ruleForm"
            >
              <el-form-item label="账号" prop="accountNumb">
                <el-input
                  v-model="params.accountNumb"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="旧密码" prop="telephone">
                <el-input
                  v-model="params.telephone"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="pwd">
                <el-input
                  v-model="params.pwd"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-form>
            <button class="primary2" @click="submitFn">提交</button>
          </div>
        </div>

        <div class="tryFooter">
          <i class="el-icon-error" @click="handleClose"></i>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: "NewPwd",
  props: ["dialogVisible"],
  data() {
    return {
      alertType:0,
      alerttext:'',
      params: {
        accountNumb: "",
        telephone: "",
        pwd:""
      },
    };
  },
  methods: {
    handleClose(done) {
      this.$emit("send");
    },
     alert (type,text) {
      console.log(type,text);
      this.dialogVisible = true
      this.alertType = type
      this.alerttext = text
    },
    async submitFn() {
      const myreg=/^[1][0-9]{10}$/;
      // const regex = /(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[a-z])(?=.*[A-Z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[0-9])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[0-9])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[a-z])(?=[0-9]))|((?=.*[A-Z])(?=.*[0-9])(?=[a-z]))|((?=.*[a-z])(?=.*[A-Z])(?=[0-9]))|((?=.*[a-z])(?=.*[0-9])(?=[A-Z]))|((?=.*[0-9])(?=.*[A-Z])(?=[a-z]))|((?=.*[0-9])(?=.*[a-z])(?=[A-Z])))^[a-zA-Z0-9]{8,16}$/gm
      if (!this.params.accountNumb) {
        this.$message.error("请输入账号");
      } else if (!this.params.telephone) {
        this.$message.error("请输入旧密码");
      }else if(!this.params.pwd) {
        this.$message.error("请输入新密码");
      }else {
        this.params.telephone = String(this.params.telephone)
       let res = await this.axios.post(api.EditPwd, this.params)
          if (res.data.code == 200) {
            this.$message.success("修改成功！");
            this.$emit("send");
          } else {
            this.$message.error("密码修改失败！请仔细核对信息输入是否正确");
          }
      }
    },
  },
};
</script>

<style lang="less">
#pwd {
  .el-dialog {
    background: transparent;
    box-shadow: none;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
}
</style>

<style lang="less" scoped>
#pwd {
  .tryFooter {
    text-align: center;
    margin-top: 5px;
    i {
      font-size: 40px;
      cursor: pointer;
      color: #fff;
    }
  }
  .loginC {
    background: #fff;
    border-radius: 5px;
    text-align: center;
    padding: 30px 20px;
    .previewLogin {
      height: 200px;
      background: url(../assets/login-reset.png) top center no-repeat;
    }
    .loginForget {
      font-size: 24px;
      color: #000000;
    }
  }
  .allMessageLogin {
    &.allMessageLoginPreview {
      padding: 30px;
    }
    .primary2 {
      width: 160px;
      margin-top: 15px;
      line-height: 42px;
      border: none;
      background-color: #82d39c;
      // background: linear-gradient(to bottom, #92c8ff, #66aff9, #489ff5);
      // border:2px solid #9acafa;
      border-radius: 8px;
      // color: #1966b3;
      font-weight: bold;
      border-color: transparent;
      box-shadow: none;
      font-size: 18px;
      letter-spacing: 4px;
      color: #fff;
      cursor: pointer;
    }
    .forgetPwd {
      text-align: left;
      span {
        cursor: pointer;
        color: #459df5;
      }
      .mima {
        float: right;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/NewPwd.vue